import { Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { SeoService } from './core/seo/seo.service';
import { organizationSchema, websiteSchema } from './core/seo/structured-data';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly seo = inject(SeoService);
  private readonly doc = inject(DOCUMENT);

  constructor() {
    // Site-wide schema (spec §8: "Global — Organization, WebSite"). These describe the site rather
    // than the page, so they are emitted once from the app shell and left alone; SeoService.setJsonLd
    // only clears the PAGE-level blocks it owns, so per-page schema never wipes these out.
    const origin = this.seo.origin;
    for (const block of [organizationSchema(origin), websiteSchema(origin)]) {
      const script = this.doc.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-seo-global', '');
      script.textContent = JSON.stringify(block).replace(/</g, '\\u003c');
      this.doc.head.appendChild(script);
    }
  }
}
